/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Colors } from './Colors';
import {
    ColorsFromJSON,
    ColorsFromJSONTyped,
    ColorsToJSON,
} from './Colors';

/**
 * 
 * @export
 * @interface ServicePackagePlanReference
 */
export interface ServicePackagePlanReference {
    /**
     * UUID of the Service Package Plan
     * @type {string}
     * @memberof ServicePackagePlanReference
     */
    id: string;
    /**
     * Name of the Service Package Plan
     * @type {string}
     * @memberof ServicePackagePlanReference
     */
    readonly name: string;
    /**
     * 
     * @type {Colors}
     * @memberof ServicePackagePlanReference
     */
    colors?: Colors | null;
}

/**
 * Check if a given object implements the ServicePackagePlanReference interface.
 */
export function instanceOfServicePackagePlanReference(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function ServicePackagePlanReferenceFromJSON(json: any): ServicePackagePlanReference {
    return ServicePackagePlanReferenceFromJSONTyped(json, false);
}

export function ServicePackagePlanReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServicePackagePlanReference {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'colors': !exists(json, 'colors') ? undefined : ColorsFromJSON(json['colors']),
    };
}

export function ServicePackagePlanReferenceToJSON(value?: ServicePackagePlanReference | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'colors': ColorsToJSON(value.colors),
    };
}

